import "./App.css";
import { Routes, Route, Navigate , RouterProvider } from "react-router-dom";
import { privateRoutes, routes } from "./pages/index";
import "bootstrap/dist/css/bootstrap.min.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./Assets/css/style.css";
import "./Assets/css/responsive.css";
import AuthLayout from "./layout/Auth/authLayout";
import MainLayout from "./layout/MainLayout/MainLayout";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";


// const staticPermissions = {
//     "Dashboard": {
//       "view": false,
//       "add_edit": false,
//       "delete": false
//     },
//     "ManageUser": {
//       "view": false,
//       "add_edit": false,
//       "delete": false
//     },
//     "ManageHotel": {
//       "view": false,
//       "add_edit": false,
//       "delete": false
//     },
//     "ManageCoupon": {
//       "view": false,
//       "add_edit": false,
//       "delete": false
//     },
//     "ManageBooking": {
//       "view": false,
//       "add_edit": false,
//       "delete": false
//     },
//     "ManagePromotion": {
//       "view": false,
//       "add_edit": false,
//       "delete": false
//     },
//     "AppIntro": {
//       "view": false,
//       "add_edit": false,
//       "delete": false
//     },
//     "Finance": {
//       "view": false,
//       "add_edit": false,
//       "delete": false
//     },
//     "ManageSupportCenter": {
//       "view": false,
//       "add_edit": false,
//       "delete": false
//     },
//     "SystemAccess": {
//       "view": false,
//       "add_edit": false,
//       "delete": false
//     },
//     "Logs": {
//       "view": false,
//       "add_edit": false,
//       "delete": false
//     },
//     "Settings": {
//       "view": false,
//       "add_edit": false,
//       "delete": false
//     }
//   }


function App() {
  const isAuthenticated = useSelector((s) => s.login?.token);
  let token = localStorage.getItem("token");
  const { t } = useTranslation();

  


  return (
    <Routes>
      {isAuthenticated || token ? (
        <Route element={<MainLayout />}>
          <Route path="*" element={<Navigate replace to="/dashboard" />} />
          {privateRoutes.map((data, index) => (
            <Route
              onUpdate={() => window.scrollTo(0, 0)}
              exact={true}
              path={data.path}
              element={data.component}
              key={index}
            />
          ))}
        </Route>
      ) : (
        <Route element={<AuthLayout />}>
          <Route path="*" element={<Navigate to="/login" />} />
          {routes.map((data, index) => (
            <Route
              onUpdate={() => window.scrollTo(0, 0)}
              exact={true}
              path={data.path}
              element={data.component}
              key={index}
            />
          ))}
        </Route>
      )}
    </Routes>
  );
}

export default App;
